import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { ButtonGhost } from '../../../components/Button';
import { BoxOpacity } from '../../../components/Box';
import { CarouselSlideTitle } from './CarouselSlideTitle';
import { SlideImageContainer } from './CarouselSlide.style';

const CarouselSlide = ({ slide, onButtonClick, index }) => {
    const {
        thumbnailImage,
        title,
        subtitle,
        price,
        priceModifier,
    } = slide.content;
    const link = get(slide, 'content.link', {});
    const { text, target, href } = link;

    const buttonClick = (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        onButtonClick({ href, target, index });
    };

    const checkThumbnailImage = (uri) => {
        return uri.match(new RegExp(/^.*\..*[^/|.]+$/));
    };

    const isThumbnailImageUri =
        thumbnailImage &&
        thumbnailImage.uri &&
        checkThumbnailImage(thumbnailImage.uri);

    const priceString = price ? ` ${priceModifier} ${price}` : '';
    const buttonText = `${text}${priceString}`;

    return (
        <BoxOpacity className="odf-flex-container-row odf-box-content-md odf-space-inner-m odf-position-relative">
            <React.Fragment>
                {isThumbnailImageUri && (
                    <SlideImageContainer className="odf-space-inner-right-s">
                        <img src={thumbnailImage.uri} alt="" />
                    </SlideImageContainer>
                )}
                <CarouselSlideTitle title={title} subtitle={subtitle} />
                {buttonText && buttonText.length > 0 && (
                    <div className="odf-space-inner-left-s">
                        <ButtonGhost
                            onClick={buttonClick}
                            target={target}
                            href={href}
                        >
                            {buttonText}
                        </ButtonGhost>
                    </div>
                )}
            </React.Fragment>
        </BoxOpacity>
    );
};

CarouselSlide.defaultProps = {
    slide: {},
    onButtonClick: () => {},
};

CarouselSlide.propTypes = {
    slide: PropTypes.object,
    onButtonClick: PropTypes.func,
    index: PropTypes.number.isRequired,
};

export { CarouselSlide };
